import styled from '@emotion/styled'
import * as RadixHoverCard from '@radix-ui/react-hover-card'
import { ReactNode } from 'react'

import { theme } from '../constants'

type HoverCardProps = {
  children: ReactNode
  trigger: ReactNode
  sideOffset?: number
  side?: 'top' | 'right' | 'bottom' | 'left'
  arrow?: boolean
}

const OPEN_DELAY = 300

const Trigger = styled(RadixHoverCard.Trigger)({
  cursor: 'default',
})

const Content = styled(RadixHoverCard.Content)`
  transform-origin: var(--radix-hover-card-content-transform-origin);

  z-index: ${theme.zIndex.hovercard};
  animation: scaleIn 0.1s cubic-bezier(0.168, 0.84, 0.44, 1);

  @keyframes scaleIn {
    from {
      opacity: 0;
      transform: scale(0);
    }
    to {
      opacity: 1;
      transform: scale(1);
    }
  }
`

const HoverCard = ({
  trigger,
  children,
  side,
  arrow = true,
  sideOffset = 5,
}: HoverCardProps) => {
  return (
    <RadixHoverCard.Root openDelay={OPEN_DELAY}>
      <Trigger asChild>{trigger}</Trigger>
      <RadixHoverCard.Portal>
        <Content sideOffset={sideOffset} side={side}>
          {children}
          {arrow && <RadixHoverCard.Arrow />}
        </Content>
      </RadixHoverCard.Portal>
    </RadixHoverCard.Root>
  )
}

HoverCard.Trigger = Trigger
HoverCard.Content = Content

export { HoverCard }
